<template>
    <div class="create-acivity">
        <div class="acivity-right">
            <div style="width: 100%; height: 100%;">
                <div class="tab-tit">
                    <ul>
                        <li @click="curId = 0" :class="{'cur' : curId >= 0}" style="width:60px">
                            <img src="../../assets/images/activity_tab1.png">
                            <p>基础设置</p>
                        </li>
                        <li @click="curId = 1" :class="{'cur' : curId >= 1}">
                            <img src="../../assets/images/activity_tab2.png" v-if="curId >= 1">
                            <img src="../../assets/images/activity_tab2_1.png" v-else>
                            <span></span>
                            <p>活动配置</p>
                        </li>
                        <li @click="curId = 2" :class="{'cur' : curId >= 2}">
                            <img src="../../assets/images/activity_tab3.png" v-if="curId >= 2">
                            <img src="../../assets/images/activity_tab3_1.png" v-else>
                            <span></span>
                            <p>奖品设置</p>
                        </li>
                        <li @click="curId = 3" :class="{'cur' : curId >= 3}">
                            <img src="../../assets/images/activity_tab4.png" v-if="curId >= 3">
                            <img src="../../assets/images/activity_tab4_1.png" v-else>
                            <span></span>
                            <p>发奖策略</p>
                        </li>
                        <li @click="addressShowFun" :class="{'cur' : curId === 4}">
                            <img src="../../assets/images/activity_tab5.png" v-if="curId >= 4">
                            <img src="../../assets/images/activity_tab5_1.png" v-else>
                            <span></span>
                            <p>界面配置</p>
                        </li>
                    </ul>
                </div>
                <div v-if="curId === 0" class="tab-con">
                    <el-form :inline="true" class="acivity-content-form" ref="formInline" :model="formInline" :rules="rules" label-width="110px">
                        <div class="new_name">基础信息 </div>
                        <el-form-item label="参与形式" prop="activity_type">
                            <el-select v-model="formInline.activity_type" placeholder="请选择参与类型">
                                <el-option v-for="item in activetyOptions" :key="item.value" :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="活动名称" prop="name">
                            <el-input v-model="formInline.name" placeholder="请输入活动名称（不能超过50字）" maxlength="50"></el-input>
                        </el-form-item>
                        <el-form-item label="活动时间">
                            <el-date-picker v-model="date" @change="dateChange" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" value-format="yyyy-MM-dd HH:mm:ss">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="活动说明" prop="description">
                            <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" placeholder="请输入内容" v-model="formInline.description" maxlength="500">
                            </el-input>
                        </el-form-item>
                        <el-form-item label="关联公众号" prop="public_id" class="public">
                            <el-select v-model="formInline.public_id" placeholder="请选择">
                                <el-option v-for="item in publicOptions" :key="item.value" :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="选择客户来源" prop="source_id" class="public">
                            <el-select filterable v-model="formInline.source_id" placeholder="请选择">
                                <el-option v-for="item in sources" :key="item.id" :label="item.name" :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="客户来源说明" prop="source_content">
                            <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" placeholder="请输入内容" v-model="formInline.source_content" maxlength="100">
                            </el-input>
                        </el-form-item>
                        <div class="new_name" @click="basicSenior = !basicSenior">高级选项 <i :class="{'el-icon-caret-bottom': !basicSenior, 'el-icon-caret-top': basicSenior}"></i> </div>
                        <el-form-item label="强制关注" v-if="basicSenior">
                            <el-radio-group v-model="formInline.draw_type">
                                <el-radio :label="1">关闭</el-radio>
                                <el-radio :label="0">开启</el-radio>
                            </el-radio-group>
                            <p style="color: #666;" v-if="formInline.draw_type === 1">可直接参加活动，活动抽奖后再关注微信公众号领奖</p>
                            <p style="color: #666;" v-if="formInline.draw_type === 0">进入活动前，需先关注微信公众号</p>
                        </el-form-item>
                    </el-form>
                    <div style="text-align: center;width: 260px;margin: 0 auto 20px;height: 36px">
                        <el-button class="dialog-confirm-btn" type="primary" style="float: left;" @click="curId = 1">下一步</el-button>
                    </div>
                </div>
                <div v-if="curId === 1" class="tab-con">
                    <el-form ref="formInline" :rules="rules" :model="formInline" :inline="true" class="acivity-setting-form" label-width="128px">
                        <div class="new_name">抽奖限制 </div>
                        <el-form-item label="总抽奖次数上限">
                            <el-input-number v-model="formInline.draw_num" controls-position="right" :min="1"></el-input-number>
                        </el-form-item>
                        <el-form-item label="单日抽奖次数上限">
                            <el-input-number v-model="formInline.everyday_draw_num" controls-position="right" :min="1"></el-input-number>
                        </el-form-item>
                        <el-form-item label="中奖个数上限">
                            <el-input-number v-model="formInline.winning_prize_num" controls-position="right" :min="1"></el-input-number>
                        </el-form-item>
                        <!-- <el-form-item label="奖品数量显示">
              <el-radio-group v-model="formInline.show_num">
                <el-radio :label="0">不显示</el-radio>
                <el-radio :label="1">显示</el-radio>
              </el-radio-group>
            </el-form-item> -->
                        <div class="new_name" @click="activitySenior = !activitySenior">高级选项 <i :class="{'el-icon-caret-bottom': !activitySenior, 'el-icon-caret-top': activitySenior}"></i> </div>
                        <div v-if="activitySenior">
                            <el-form-item label="是否微信分享">
                                <el-radio-group v-model="formInline.wechat_share" @change="wechatShareChange">
                                    <el-radio :label="0">禁止分享</el-radio>
                                    <el-radio :label="1">允许分享</el-radio>
                                </el-radio-group>
                                <div v-if="formInline.wechat_share === 1" class="cover_img">
                                    <el-upload class="avatar-uploader" name="file_upload" :action="uploadURL" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
                                        <img v-if="formInline.share_img" :src="formInline.share_img" class="avatar">
                                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                    </el-upload>
                                    <p style="margin:0 8px;line-height:20px;margin-bottom:8px;">请上传jpg,png格式的图片</p>
                                    <el-form-item label="标题" label-width="50px" style="padding-left:0">
                                        <el-input v-model="formInline.share_title" placeholder="25字以内" maxlength="25" style="width:245px;"></el-input>
                                    </el-form-item>
                                    <el-form-item label="描述" label-width="50px" style="padding-left:0">
                                        <el-input v-model="formInline.share_description" type="textarea" :autosize="{ minRows: 2, maxRows: 4}" placeholder="50字以内" maxlength="50" style="width:245px;"></el-input>
                                    </el-form-item>
                                </div>
                            </el-form-item>
                            <el-form-item label="邀请好友助力">
                                <el-radio-group v-model="formInline.assistance_status" @change="assistanceStatusChange">
                                    <el-radio :disabled="formInline.wechat_share === 0" :label="2">关闭</el-radio>
                                    <el-radio :disabled="formInline.wechat_share === 0" :label="1">开启</el-radio>
                                </el-radio-group>
                                <p class="wechat_share" v-if="formInline.assistance_status === 1">
                                    每参加一场活动，成功邀请一位好友助力，当天将额外获得一次抽奖机会<br>单场活动最多获得机会
                                    <el-input-number v-model="formInline.everyactivity_assistance_prize_num" controls-position="right" :min="1" style="width:88px;margin-bottom: 5px;" :disabled="formInline.wechat_share === 0"></el-input-number>
                                    次<br>每天最多获得机会
                                    <el-input-number v-model="formInline.everyday_assistance_prize_num" controls-position="right" :min="1" style="width:88px;" :disabled="formInline.wechat_share === 0"></el-input-number>
                                    次
                                </p>
                            </el-form-item>
                            <el-form-item label="为好友助力">
                                <el-radio-group v-model="formInline.assistance_prize_status">
                                    <el-radio :disabled="formInline.wechat_share === 0 || formInline.assistance_status === 2" :label="0">无奖励</el-radio>
                                    <el-radio :disabled="formInline.wechat_share === 0 || formInline.assistance_status === 2" :label="1">助力奖励</el-radio>
                                </el-radio-group>
                                <p class="wechat_share" v-if="formInline.assistance_prize_status === 1">为好友助力后可同时获得抽奖机会一次<br>每人每天可为同一好友助力
                                    <el-input-number v-model="formInline.everyday_assistance_one_num" controls-position="right" :min="1" style="width:88px;margin-bottom: 5px;" :disabled="formInline.wechat_share === 0 || formInline.assistance_status === 2 || formInline.assistance_prize_status === 0"></el-input-number>
                                    次<br>每天最多助力
                                    <el-input-number v-model="formInline.everyday_assistance_num" controls-position="right" :min="1" style="width:88px" :disabled="formInline.wechat_share === 0 || formInline.assistance_status === 2 || formInline.assistance_prize_status === 0"></el-input-number>次
                                </p>
                            </el-form-item>
                        </div>
                        <el-form-item class="button-content">
                            <el-button class="dialog-confirm-btn" type="primary" @click="curId = 2" style="margin-right: 85px;margin-left: 10px">下一步</el-button>
                            <el-button class="dialog-cancel-btn" @click="curId = 0" style="margin-left: 55px">上一步</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <div v-if="curId === 2" class="tab-con">
                    <el-form :inline="false" class="acivity-prize-form">
                        <div class="new_name" style="margin-bottom:10px;padding-bottom: 10px">主奖池 &nbsp;&nbsp;&nbsp;&nbsp;<span style="color:#F56C6C;margin-right:3px;">*</span>预计活动人数：
                            <el-input v-model="formInline.active_number" placeholder="" style="width:100px;"></el-input>
                            人
                            <el-tooltip class="item" effect="dark" content="预估活动人数直接影响抽奖概率：中奖概率 = 奖品总数/(预估活动人数*每人每天最多抽奖次数*活动天数)" placement="right">
                                <i class="el-icon-question"></i>
                            </el-tooltip>
                        </div>
                        <div class="new-add-setting">
                            奖品设置至少1个，至多6个
                            <el-button type="primary" style="margin-top: 3px;float: none" @click="addPrizeAction">新增</el-button>
                        </div>
                        <div class="new-add-table">
                            <el-table :data="formInline.prize" border class="table" style="margin:0">
                                <el-table-column label="奖品等级" width="90">
                                    <template slot-scope="scope">
                                        <span>{{level[scope.$index]}}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="奖品类型" width="150">
                                    <template slot-scope="scope">
                                        <el-select v-model="scope.row.prize_type" placeholder="请选择奖品类型">
                                            <el-option v-for="item in prizeOptions" :key="item.value" :label="item.label" :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </template>
                                </el-table-column>
                                <el-table-column label="奖品内容" width="220">
                                    <template slot-scope="scope">
                                        <div v-if="scope.row.prize_type === 2" style="display: flex;justify-content: flex-start; flex-direction: row">
                                            <el-input-number class="prize-count-special" v-model="scope.row.prize_min_money" controls-position="right" :min="1">
                                            </el-input-number>
                                            <span class="money-span">至</span>
                                            <el-input-number class="prize-count-special" v-model="scope.row.prize_max_money" controls-position="right" :min="1">
                                            </el-input-number>
                                        </div>
                                        <el-input v-else v-model="scope.row.prize_name" placeholder="如:手机一部"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column label="奖品编号" min-width="120">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.prize_type === 2">无需填写</span>
                                        <el-input v-else v-model="scope.row.prize_number" class="" style="width: 100%" placeholder="奖品编号"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="start" label="奖品数量" width="120">
                                    <template slot-scope="scope">
                                        <el-input-number v-model="scope.row.prize_num" class="prize-count" controls-position="right" :min="1"></el-input-number>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="start" label="显示数量" width="120">
                                    <template slot-scope="scope">
                                        <el-input-number v-model="scope.row.prize_num_show" class="prize-count" controls-position="right"></el-input-number>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="start" width="120">
                                    <template slot="header" slot-scope="scope">
                                        奖品图片
                                        <el-tooltip class="item" effect="dark" content="建议尺寸100px*100px，大小500kb以内，格式为jpg,png" placement="right">
                                            <i class="el-icon-question"></i>
                                        </el-tooltip>
                                    </template>
                                    <template slot-scope="scope">
                                        <div style="position:relative">
                                            <el-upload class="avatar-uploader" name="file_upload" :action="uploadURL" :show-file-list="false" :on-success="(res, file) => { return handlePrizeSuccess(res, file, scope.$index)}" :before-upload="beforeAvatarUpload">
                                                <img v-if="scope.row.prize_img" :src="scope.row.prize_img" class="avatar">
                                                <el-button size="small" type="primary" v-else style="margin-top:0">点击上传</el-button>
                                                <i v-if="scope.row.prize_img" class="removeImg el-icon-circle-close-outline" @click="handlePrizeRemove('prize', scope.$index)" style="top: -9px;right: 15px"></i>
                                            </el-upload>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column width="100" label="操作" style="display: flex;justify-content: center">
                                    <template slot-scope="scope">
                                        <el-tooltip class="item" effect="dark" content="删除" placement="bottom">
                                            <div class="op-link">
                                                <i class="" style="font-size: 14px;font-style: normal" @click="deleteRow(scope.$index, formInline.prize)">删除</i>
                                            </div>
                                        </el-tooltip>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                        <div class="new_name" style="margin:20px 0 10px 0;padding-bottom: 10px">助力奖池 &nbsp;&nbsp;&nbsp;&nbsp;<span style="color:#F56C6C;margin-right:3px;">*</span>预计活动人数：
                            <el-input v-model="formInline.assistance_active_number" placeholder="" style="width:100px;"></el-input>
                            人
                            <el-tooltip class="item" effect="dark" content="预估活动人数直接影响抽奖概率：中奖概率 = 奖品总数/(预估活动人数*每人每天最多抽奖次数*活动天数)" placement="right">
                                <i class="el-icon-question"></i>
                            </el-tooltip>
                        </div>
                        <div class="new-add-setting">
                            <!-- <el-switch :active-value="1" :inactive-value="2" v-model="formInline.assistance_status" active-color="#13ce66" inactive-color="#ff4949">
              </el-switch> -->
                            邀请好友助力后，客户和助力好友后均在助力奖池中进行抽奖，奖品设置至少1个，至多6个
                            <el-button type="primary" style="margin-top: 3px;float: none" @click="addAssistancePrizeAction">新增</el-button>
                        </div>
                        <div class="new-add-table">
                            <el-table :data="formInline.assistance_prize" border class="table" style="margin:0">
                                <el-table-column label="奖品等级" width="90">
                                    <template slot-scope="scope">
                                        <span>{{level[scope.$index]}}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="奖品类型" width="150">
                                    <template slot-scope="scope">
                                        <el-select v-model="scope.row.prize_type" placeholder="请选择奖品类型">
                                            <el-option v-for="item in prizeOptions" :key="item.value" :label="item.label" :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </template>
                                </el-table-column>
                                <el-table-column label="奖品内容" width="220">
                                    <template slot-scope="scope">
                                        <div v-if="scope.row.prize_type === 2" style="display: flex;justify-content: flex-start; flex-direction: row">
                                            <el-input-number class="prize-count-special" v-model="scope.row.prize_min_money" controls-position="right" :min="1">
                                            </el-input-number>
                                            <span class="money-span">至</span>
                                            <el-input-number class="prize-count-special" v-model="scope.row.prize_max_money" controls-position="right" :min="1">
                                            </el-input-number>
                                        </div>
                                        <el-input v-else v-model="scope.row.prize_name" placeholder="如:手机一部"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column label="奖品编号" min-width="120">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.prize_type === 2">无需填写</span>
                                        <el-input v-else v-model="scope.row.prize_number" class="" style="width: 100%" placeholder="奖品编号"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="start" label="奖品数量" width="120">
                                    <template slot-scope="scope">
                                        <el-input-number v-model="scope.row.prize_num" class="prize-count" controls-position="right" :min="1"></el-input-number>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="start" label="显示数量" width="120">
                                    <template slot-scope="scope">
                                        <el-input-number v-model="scope.row.prize_num_show" class="prize-count" controls-position="right"></el-input-number>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="start" width="120">
                                    <template slot="header" slot-scope="scope">
                                        奖品图片
                                        <el-tooltip class="item" effect="dark" content="建议尺寸100px*100px，大小500kb以内，格式为jpg,png" placement="right">
                                            <i class="el-icon-question"></i>
                                        </el-tooltip>
                                    </template>
                                    <template slot-scope="scope">
                                        <div style="position:relative">
                                            <el-upload class="avatar-uploader" name="file_upload" :action="uploadURL" :show-file-list="false" :on-success="(res, file) => { return handleAssistancePrizeSuccess(res, file, scope.$index)}" :before-upload="beforeAvatarUpload">
                                                <img v-if="scope.row.prize_img" :src="scope.row.prize_img" class="avatar">
                                                <el-button size="small" type="primary" v-else style="margin-top:0">点击上传</el-button>
                                                <i v-if="scope.row.prize_img" class="removeImg el-icon-circle-close-outline" @click="handlePrizeRemove('assistance_prize', scope.$index)" style="top: -9px;right: 15px"></i>
                                            </el-upload>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column width="100" label="操作" style="display: flex;justify-content: center">
                                    <template slot-scope="scope">
                                        <el-tooltip class="item" effect="dark" content="删除" placement="bottom">
                                            <div class="op-link">
                                                <i class="" style="font-size: 14px;font-style: normal" @click="deleteAssistanceRow(scope.$index, formInline.assistance_prize)">删除</i>
                                            </div>
                                        </el-tooltip>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                        <el-form-item class="button-content">
                            <el-button class="dialog-cancel-btn" style="margin-right: 10px;" @click="curId = 1">上一步</el-button>
                            <el-button class="dialog-confirm-btn" type="primary" @click="curId = 3">下一步</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <div v-if="curId === 3" class="tab-con">
                    <el-form :inline="false" class="acivity-prize-form">
                        <div class="new_name">指定布奖次数 </div>
                        <div class="new-add-setting">
                            指定第几次参与活动可获得指定奖励
                            <el-switch :active-value="1" :inactive-value="2" v-model="formInline.strategystate" active-color="#13ce66" inactive-color="#ff4949">
                            </el-switch>
                            <el-button type="primary" style="margin-top: 3px;float: right" @click="addNumberAwards">新增</el-button>
                        </div>
                        <div class="new-add-table">
                            <el-table :data="formInline.strategy" border class="table" style="margin:0">
                                <el-table-column label="奖品等级" min-width="90">
                                    <template slot-scope="scope">
                                        <el-select v-model="scope.row.prize_level" placeholder="请选择奖品类型">
                                            <el-option v-for="(item,index) in formInline.prize" :key="index" :label="level[index]" :value="(index + 1)">
                                            </el-option>
                                        </el-select>
                                    </template>
                                </el-table-column>
                                <el-table-column label="周期" min-width="170">
                                    <template slot-scope="scope">
                                        <el-select v-model="scope.row.cycle_type" placeholder="请选择奖品类型">
                                            <el-option v-for="item in cycleOptions" :key="item.value" :label="item.label" :value="item.text">
                                            </el-option>
                                        </el-select>
                                    </template>
                                </el-table-column>
                                <el-table-column label="指定次数" min-width="170">
                                    <template slot-scope="scope">
                                        <el-input-number v-model="scope.row.specified_times" class="prize-count" controls-position="right" :min="1" style="width:180px;"></el-input-number>
                                    </template>
                                </el-table-column>
                                <el-table-column min-width="150" label="操作" style="display: flex;justify-content: center">
                                    <template slot-scope="scope">
                                        <el-tooltip class="item" effect="dark" content="删除" placement="bottom">
                                            <div class="op-link">
                                                <i class="" style="font-size: 14px;font-style: normal" @click="deleteStrategyRow(scope.row)">删除</i>
                                            </div>
                                        </el-tooltip>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                        <div class="new_name" @click="prizeArea = !prizeArea">指定布奖区域 <i :class="{'el-icon-caret-bottom': !prizeArea, 'el-icon-caret-top': prizeArea}"></i> </div>
                        <div class="new-add-setting" v-if="prizeArea">
                            指定省市区县的中奖数量
                            <el-switch :active-value="1" :inactive-value="2" v-model="formInline.strategyareastate" active-color="#13ce66" inactive-color="#ff4949">
                            </el-switch>
                            <el-button type="primary" style="margin-top: 3px;float: right" @click="addPrizeArea">新增</el-button>
                        </div>
                        <div class="new-add-table" v-if="prizeArea">
                            <el-table :data="formInline.strategyarea" border class="table" style="margin:0">
                                <el-table-column label="奖品等级" min-width="90">
                                    <template slot-scope="scope">
                                        <el-select v-model="scope.row.prize_level" placeholder="请选择奖品类型">
                                            <el-option v-for="(item,index) in formInline.prize" :key="index" :label="level[index]" :value="(index + 1)">
                                            </el-option>
                                        </el-select>
                                    </template>
                                </el-table-column>
                                <el-table-column label="中奖区域" min-width="170">
                                    <template slot-scope="scope">
                                        <el-cascader size="large" :options="options" v-model="scope.row.region">
                                        </el-cascader>
                                    </template>
                                </el-table-column>
                                <el-table-column label="中奖数量" min-width="170">
                                    <template slot-scope="scope">
                                        <el-input-number v-model="scope.row.number" class="prize-count" controls-position="right" :min="1" style="width:180px;"></el-input-number>
                                    </template>
                                </el-table-column>
                                <el-table-column min-width="150" label="操作" style="display: flex;justify-content: center">
                                    <template slot-scope="scope">
                                        <el-tooltip class="item" effect="dark" content="删除" placement="bottom">
                                            <div class="op-link">
                                                <i class="" style="font-size: 14px;font-style: normal" @click="deleteStrategyRow4(scope.row)">删除</i>
                                            </div>
                                        </el-tooltip>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                        <div class="new_name" @click="timeSlot = !timeSlot">指定时间段布奖 <i :class="{'el-icon-caret-bottom': !timeSlot, 'el-icon-caret-top': timeSlot}"></i> </div>
                        <div class="new-add-setting" v-if="timeSlot">
                            指定每个时间段的中奖数量
                            <el-switch :active-value="1" :inactive-value="2" v-model="formInline.strategytimestate" active-color="#13ce66" inactive-color="#ff4949">
                            </el-switch>
                            <el-button type="primary" style="margin-top: 3px;float: right" @click="addtimeSlotArea">新增</el-button>
                        </div>
                        <div class="new-add-table" v-if="timeSlot">
                            <el-table :data="formInline.strategytime" border class="table" style="margin:0">
                                <el-table-column label="奖品等级" min-width="110">
                                    <template slot-scope="scope">
                                        <el-select v-model="scope.row.prize_level" placeholder="请选择奖品类型">
                                            <el-option v-for="(item,index) in formInline.prize" :key="index" :label="level[index]" :value="(index + 1)">
                                            </el-option>
                                        </el-select>
                                    </template>
                                </el-table-column>
                                <el-table-column label="周期" min-width="370">
                                    <template slot-scope="scope">
                                        <el-select v-model="scope.row.cycle_type" placeholder="请选择奖品类型" style="width:120px;float:left">
                                            <el-option v-for="item in cycleTimeOptions" :key="item.value" :label="item.label" :value="item.text">
                                            </el-option>
                                        </el-select>
                                        <el-date-picker v-if="scope.row.cycle_type === 'custom'" v-model="scope.row.date" type="daterange" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" :picker-options="pickerAppointedOptions" style="width:225px;float:left;margin-left:8px;">
                                        </el-date-picker>
                                    </template>
                                </el-table-column>
                                <el-table-column label="时间段" min-width="250">
                                    <template slot-scope="scope">
                                        <el-time-picker is-range v-model="scope.row.time" range-separator="-" start-placeholder="开始时间" end-placeholder="结束时间" format="HH:mm" value-format="HH:mm" placeholder="选择时间范围" style="width:220px;">
                                        </el-time-picker>
                                    </template>
                                </el-table-column>
                                <el-table-column label="数量" min-width="220">
                                    <template slot-scope="scope">
                                        <el-input-number v-model="scope.row.number" class="prize-count" controls-position="right" :min="1" style="width:180px;"></el-input-number>
                                    </template>
                                </el-table-column>
                                <el-table-column width="100" label="操作" style="display: flex;justify-content: center">
                                    <template slot-scope="scope">
                                        <el-tooltip class="item" effect="dark" content="删除" placement="bottom">
                                            <div class="op-link">
                                                <i class="deleteColor" style="font-size: 14px;font-style: normal" @click="deleteStrategyRow5(scope.row)">删除</i>
                                            </div>
                                        </el-tooltip>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                        <el-form-item class="button-content">
                            <el-button class="dialog-confirm-btn" type="primary" @click="addressShowFun" style="margin-right: 85px;margin-left: 10px">下一步</el-button>
                            <el-button class="dialog-cancel-btn" @click="curId = 2" style="margin-left: 55px">上一步</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <div v-if="curId === 4" style="width: 95%;overflow-x: auto;margin-left: 5%;">
                    <div style="display: flex;padding-top:20px;min-width:1087px;">
                        <div class="interface_tab">
                            <ul>
                                <li @click="interfaceId = 0" :class="{'interfaceId' : interfaceId === 0}">首页</li>
                                <li @click="interfaceFun(1)" :class="{'interfaceId' : interfaceId === 1}">中奖页面</li>
                                <li @click="interfaceFun(2)" :class="{'interfaceId' : interfaceId === 2}">未中奖页面</li>
                                <li v-if="addressShow" @click="interfaceId = 3" :class="{'interfaceId' : interfaceId === 3}">收货地址</li>
                                <li v-if="formInline.assistance_status === 1" @click="interfaceFun(4)" :class="{'interfaceId' : interfaceId === 4}">助力页面</li>
                                <li @click="interfaceId = 5" :class="{'interfaceId' : interfaceId === 5}">关注微信</li>
                                <li @click="interfaceId = 6" :class="{'interfaceId' : interfaceId === 6}">预热页面</li>
                            </ul>
                        </div>
                        <div class="interface">
                            <div id="interfaceImg" class="interface_img " :style="{'overflow-y' : (interfaceId === 1 || interfaceId === 2 || interfaceId === 4)?'hidden':'auto'}">
                                <div class="mask" v-if="(interfaceId === 1 || interfaceId === 2 || interfaceId === 4)">
                                    <div v-if="interfaceId === 1" style="width:70%;margin: 45% auto 12px;position:relative">
                                        <img src="../../assets/images/interface_close.png" class="close">
                                        <img :src="formInline.prize[0].prize_img?formInline.prize[0].prize_img:require('../../assets/images/interface_pri1.png')" class="interface_prize" alt="奖品">
                                        <p style="position: absolute;top: 64%;left: 39%;color: #fff;">一等奖</p>
                                        <img :src="formInline.getprize_img?formInline.getprize_img:require('../../assets/images/getprize_img.png')" style="width:100%;display: block;height:252px" alt="中奖背景图">
                                        <img :src="formInline.getprize_btn_img?formInline.getprize_btn_img:require('../../assets/images/getprize_btn_img.png')" style="width:160px;margin: 20px auto 12px;display: block;height:33px;" alt="领奖按钮">
                                    </div>
                                    <div v-if="interfaceId === 2" style="width:70%;margin: 45% auto 12px;position:relative">
                                        <img src="../../assets/images/interface_close.png" class="close">
                                        <img :src="formInline.noprize_img?formInline.noprize_img:require('../../assets/images/noprize_img.png')" style="width:100%;display: block;height:252px" alt="未中奖背景图">
                                        <img :src="formInline.assistance_share_btn_img?formInline.assistance_share_btn_img:require('../../assets/images/assistance_share_btn_img.png')" style="width:160px;margin: 20px auto 12px;display: block;height:33px;" alt="领奖按钮">
                                    </div>
                                    <div v-if="interfaceId === 4" style="width:70%;margin: 45% auto 12px;position:relative">
                                        <img src="../../assets/images/interface_close.png" class="close">
                                        <img :src="formInline.assistance_img?formInline.assistance_img:require('../../assets/images/assistance_img.png')" style="width:100%;display: block;height:252px" alt="助力背景图">
                                        <img :src="formInline.assistance_btn_img?formInline.assistance_btn_img:require('../../assets/images/assistance_btn_img.png')" style="width:160px;margin: 20px auto 12px;display: block;height:33px;" alt="助力按钮">
                                    </div>
                                </div>
                                <div class="interface_con interface_hei" v-if="interfaceId === 1 || interfaceId === 2 || interfaceId === 0 || interfaceId === 4" :style="{backgroundImage:'url(' + (formInline.background_img?formInline.background_img:require('../../assets/images/interface_bg.png')) + ')'}">
                                    <img :src="formInline.cover_img?formInline.cover_img:require('../../assets/images/interface_title.png')" style="width:100%;margin-top:51pt" alt="活动标题">
                                    <div style="width:100%;position:relative;height:230px;">
                                        <img :src="formInline.active_img?formInline.active_img:require('../../assets/images/interface_altar.png')" alt="酒坛" class="interface_altar">
                                        <img :src="formInline.active_img?formInline.active_img:require('../../assets/images/interface_altar.png')" alt="酒坛" class="interface_altar" style="left: 86px;z-index: 1;top: 0;">
                                        <img :src="formInline.active_img?formInline.active_img:require('../../assets/images/interface_altar.png')" alt="酒坛" class="interface_altar" style="left:166px">
                                        <img :src="formInline.active_btn_img?formInline.active_btn_img:require('../../assets/images/interface_altar_open.png')" alt="开酒坛" class="interface_altar_open">
                                        <img :src="formInline.active_btn_img?formInline.active_btn_img:require('../../assets/images/interface_altar_open.png')" alt="开酒坛" class="interface_altar_open" style="left:137px;top:135px">
                                        <img :src="formInline.active_btn_img?formInline.active_btn_img:require('../../assets/images/interface_altar_open.png')" alt="开酒坛" class="interface_altar_open" style="left:231px">
                                    </div>
                                    <!-- <img src="../../assets/images/interface_news.png" style="width:100%;margin-top:0pt" alt=""> -->
                                    <img :src="formInline.prizeshow_img?formInline.prizeshow_img:require('../../assets/images/interface_prize.png')" style="width:135px;margin: 20px auto 12px;display: block" alt="奖品展示">
                                    <div class="interface_prize_new">
                                        <ul :style="{'width': (71 * (formInline.prize.length)) + 'px'}">
                                            <li v-for="(item, index) in formInline.prize" :key="index">
                                                <div>
                                                    <img :src="item.prize_img?item.prize_img:require('../../assets/images/interface_pri1.png')">
                                                </div>
                                                <p>{{level[index]}}{{(formInline.show_num === 1)&&(item.prize_num_show != 0)? ('(' + item.prize_num_show + ')') : ''}}</p>
                                            </li>
                                        </ul>
                                    </div>
                                    <img :src="formInline.intro_img?formInline.intro_img:require('../../assets/images/interface_rule.png')" style="width:135px;margin: 20px auto 12px;display: block" alt="活动规则">
                                    <div class="interface_prize_new interface_rule">
                                        <p>{{formInline.description}}</p>
                                    </div>
                                </div>
                                <div class="interface_con harvest_con" v-if="interfaceId === 3" :style="{backgroundImage:'url(' + (formInline.receiveprize_bg_img?formInline.receiveprize_bg_img:require('../../assets/images/interface_harvest.png')) + ')'}">
                                    <div class="harvest">
                                        <p>请填写收货人姓名</p>
                                    </div>
                                    <div class="harvest">
                                        <p>请填写收货人联系方式</p>
                                    </div>
                                    <div class="harvest">
                                        <p>省市区县</p>
                                    </div>
                                    <div class="harvest">
                                        <p>请填写详细地址</p>
                                    </div>
                                    <img :src="formInline.receiveprize_btn_img?formInline.receiveprize_btn_img:require('../../assets/images/getprize_btn_img.png')" style="width:160px;margin: 20px auto 12px;display: block;height:34px;" alt="领奖按钮">
                                </div>
                                <!-- 关注微信显示界面 -->
                                <div class="interface_con" v-if="interfaceId === 5" :style="{backgroundImage:'url(' + (formInline.qrcode_bg_img?formInline.qrcode_bg_img:require('../../assets/images/interface_er.png')) + ')'}">
                                    <img :src="formInline.qrcode_img?formInline.qrcode_img:require('../../assets/images/qrcodeImg.jpg')" style="width:140px;margin: 315px auto 12px;display: block;" alt="二维码">
                                    <p class="qrcode_con">长按识别二维码，关注公众号</p>
                                    <p class="qrcode_con" style="color:#FFC900">关注后重新扫描瓶盖内码领奖</p>
                                </div>
                                <!-- 预热显示界面 -->
                                <div class="interface_con" v-if="interfaceId === 6" :style="{backgroundImage:'url(' + (formInline.preheat_bg_img?formInline.preheat_bg_img:require('../../assets/images/preheat_bg_img.png')) + ')'}">
                                    <img :src="formInline.preheat_btn_img?formInline.preheat_btn_img:require('../../assets/images/preheat_btn_img.png')" style="width:260px;margin: 433px auto 12px;display: block;height:40px" alt="预热按钮">
                                </div>
                            </div>
                        </div>
                        <div v-if="interfaceId === 0" class="interface_form">
                            <el-form :inline="false" class="acivity-prize-form">
                                <el-form-item label="背景图片" class="cover_img" style="border:none;text-align:left;margin-bottom:0">
                                    <el-upload class="avatar-uploader" name="file_upload" :action="uploadURL" :show-file-list="false" :on-success="(res, file) => { return handleInterfaceSuccess(res, file, 'background_img')}" :before-upload="beforeAvatarUpload">
                                        <img :src="formInline.background_img?formInline.background_img:require('../../assets/images/interface_bg.png')" style="width:80px;height:180px;display:block;">
                                        <!-- <i v-else class="el-icon-plus avatar-uploader-icon"></i> -->
                                        <i v-if="formInline.background_img" class="removeImg el-icon-circle-close-outline" @click="handleRemove('background_img')"></i>
                                    </el-upload>
                                    <p class="interface_update_p" style="margin-left:171px">建议尺寸375px*1164px，大小500kb以内，格式为jpg,png
                                    </p>
                                </el-form-item>
                                <el-form-item label="主题图片" class="cover_img" style="border:none;text-align:left;margin-bottom:0">
                                    <el-upload class="avatar-uploader" name="file_upload" :action="uploadURL" :show-file-list="false" :on-success="(res, file) => { return handleInterfaceSuccess(res, file, 'cover_img')}" :before-upload="beforeAvatarUpload">
                                        <img :src="formInline.cover_img?formInline.cover_img:require('../../assets/images/interface_title.png')" style="width:160px;height:88px;display:block;">
                                        <!-- <i v-else class="el-icon-plus avatar-uploader-icon"></i> -->
                                        <i v-if="formInline.cover_img" class="removeImg el-icon-circle-close-outline" @click="handleRemove('cover_img')"></i>
                                    </el-upload>
                                    <p class="interface_update_p" style="margin-left:247px">建议尺寸375px*190px，大小500kb以内，格式为jpg,png</p>
                                </el-form-item>
                                <el-form-item label="酒坛图片" class="cover_img" style="border:none;text-align:left;margin-bottom:0">
                                    <el-upload class="avatar-uploader" name="file_upload" :action="uploadURL" :show-file-list="false" :on-success="(res, file) => { return handleInterfaceSuccess(res, file, 'active_img')}" :before-upload="beforeAvatarUpload">
                                        <img :src="formInline.active_img?formInline.active_img:require('../../assets/images/interface_altar.png')" style="width:61px;height:68px;display:block;">
                                        <!-- <i v-else class="el-icon-plus avatar-uploader-icon"></i> -->
                                        <i v-if="formInline.active_img" class="removeImg el-icon-circle-close-outline" @click="handleRemove('active_img')"></i>
                                    </el-upload>
                                    <p class="interface_update_p" style="margin-left:150px">建议尺寸170px*230px，大小500kb以内，格式为jpg,png</p>
                                </el-form-item>
                                <el-form-item label="按钮图片" class="cover_img" style="border:none;text-align:left;margin-bottom:0">
                                    <el-upload class="avatar-uploader" name="file_upload" :action="uploadURL" :show-file-list="false" :on-success="(res, file) => { return handleInterfaceSuccess(res, file, 'active_btn_img')}" :before-upload="beforeAvatarUpload">
                                        <img :src="formInline.active_btn_img?formInline.active_btn_img:require('../../assets/images/interface_altar_open.png')" style="width:37px;height:37px;display:block;">
                                        <i v-if="formInline.active_btn_img" class="removeImg el-icon-circle-close-outline" @click="handleRemove('active_btn_img')"></i>
                                    </el-upload>
                                    <p class="interface_update_p" style="margin-left:125px">建议尺寸45px*45px，大小500kb以内，格式为jpg,png</p>
                                </el-form-item>
                                <el-form-item label="奖品展示" class="cover_img" style="border:none;text-align:left;margin-bottom:0">
                                    <el-upload class="avatar-uploader" name="file_upload" :action="uploadURL" :show-file-list="false" :on-success="(res, file) => { return handleInterfaceSuccess(res, file, 'prizeshow_img')}" :before-upload="beforeAvatarUpload">
                                        <img :src="formInline.prizeshow_img?formInline.prizeshow_img:require('../../assets/images/interface_prize.png')" style="width:99px;height:28px;display:block;">
                                        <i v-if="formInline.prizeshow_img" class="removeImg el-icon-circle-close-outline" @click="handleRemove('prizeshow_img')"></i>
                                    </el-upload>
                                    <p class="interface_update_p" style="margin-left:187px">建议尺寸120px*32px，大小500kb以内，格式为jpg,png</p>
                                </el-form-item>
                                <el-form-item label="活动说明" class="cover_img" style="border:none;text-align:left;margin-bottom:0">
                                    <el-upload class="avatar-uploader" name="file_upload" :action="uploadURL" :show-file-list="false" :on-success="(res, file) => { return handleInterfaceSuccess(res, file, 'intro_img')}" :before-upload="beforeAvatarUpload">
                                        <img :src="formInline.intro_img?formInline.intro_img:require('../../assets/images/interface_rule.png')" style="width:99px;height:28px;display:block;">
                                        <i v-if="formInline.intro_img" class="removeImg el-icon-circle-close-outline" @click="handleRemove('intro_img')"></i>
                                    </el-upload>
                                    <p class="interface_update_p" style="margin-left:187px">建议尺寸120px*32px，大小500kb以内，格式为jpg,png</p>
                                </el-form-item>
                                <el-form-item label="奖品数量" class="cover_img" style="border:none;text-align:left;margin-bottom:0">
                                    <el-radio-group v-model="formInline.show_num">
                                        <el-radio :label="1">显示</el-radio>
                                        <el-radio :label="0">不显示</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </el-form>
                        </div>
                        <div v-if="interfaceId === 1" class="interface_form">
                            <el-form :inline="false" class="acivity-prize-form" label-width="85px" label-position="left">
                                <el-form-item label="中奖背景图" class="cover_img" style="border:none;text-align:left;margin-bottom:0">
                                    <el-upload class="avatar-uploader" name="file_upload" :action="uploadURL" :show-file-list="false" :on-success="(res, file) => { return handleInterfaceSuccess(res, file, 'getprize_img')}" :before-upload="beforeAvatarUpload">
                                        <img :src="formInline.getprize_img?formInline.getprize_img:require('../../assets/images/getprize_img.png')" style="width:160px;height:177px;display:block;">
                                        <i v-if="formInline.getprize_img" class="removeImg el-icon-circle-close-outline" @click="handleRemove('getprize_img')"></i>
                                    </el-upload>
                                    <p class="interface_update_p" style="margin-left:190px">建议尺寸270px*300px，大小500kb以内，格式为jpg,png</p>
                                </el-form-item>
                                <el-form-item label="点击领取" class="cover_img" style="border:none;text-align:left;margin-bottom:0">
                                    <el-upload class="avatar-uploader" name="file_upload" :action="uploadURL" :show-file-list="false" :on-success="(res, file) => { return handleInterfaceSuccess(res, file, 'getprize_btn_img')}" :before-upload="beforeAvatarUpload">
                                        <img :src="formInline.getprize_btn_img?formInline.getprize_btn_img:require('../../assets/images/getprize_btn_img.png')" style="width:99px;height:28px;display:block;">
                                        <i v-if="formInline.getprize_btn_img" class="removeImg el-icon-circle-close-outline" @click="handleRemove('getprize_btn_img')"></i>
                                    </el-upload>
                                    <p class="interface_update_p" style="margin-left:130px">建议尺寸160px*32px，大小500kb以内，格式为jpg,png</p>
                                </el-form-item>
                            </el-form>
                        </div>
                        <div v-if="interfaceId === 2" class="interface_form">
                            <el-form :inline="false" class="acivity-prize-form" label-width="100px" label-position="left">
                                <el-form-item label="未中奖背景图" class="cover_img" style="border:none;text-align:left;margin-bottom:0">
                                    <el-upload class="avatar-uploader" name="file_upload" :action="uploadURL" :show-file-list="false" :on-success="(res, file) => { return handleInterfaceSuccess1(res, file, 'noprize_img')}" :before-upload="beforeAvatarUpload">
                                        <img :src="formInline.noprize_img?formInline.noprize_img:require('../../assets/images/noprize_img.png')" style="width:160px;height:177px;display:block;">
                                        <i v-if="formInline.noprize_img" class="removeImg el-icon-circle-close-outline" @click="handleRemove('noprize_img')"></i>
                                    </el-upload>
                                    <p class="interface_update_p" style="margin-left:190px">建议尺寸270px*300px，大小500kb以内，格式为jpg,png</p>
                                </el-form-item>
                                <el-form-item label="点击领取" class="cover_img" style="border:none;text-align:left;margin-bottom:0">
                                    <el-upload class="avatar-uploader" name="file_upload" :action="uploadURL" :show-file-list="false" :on-success="(res, file) => { return handleInterfaceSuccess1(res, file, 'assistance_share_btn_img')}" :before-upload="beforeAvatarUpload">
                                        <img :src="formInline.assistance_share_btn_img?formInline.assistance_share_btn_img:require('../../assets/images/assistance_share_btn_img.png')" style="width:99px;height:28px;display:block;">
                                        <i v-if="formInline.assistance_share_btn_img" class="removeImg el-icon-circle-close-outline" @click="handleRemove('assistance_share_btn_img')"></i>
                                    </el-upload>
                                    <p class="interface_update_p" style="margin-left:130px">建议尺寸160px*32px，大小500kb以内，格式为jpg,png</p>
                                </el-form-item>
                            </el-form>
                        </div>
                        <div v-if="interfaceId === 3" class="interface_form">
                            <el-form :inline="false" class="acivity-prize-form" label-width="85px" label-position="left">
                                <el-form-item label="领奖背景图" class="cover_img" style="border:none;text-align:left;margin-bottom:0">
                                    <el-upload class="avatar-uploader" name="file_upload" :action="uploadURL" :show-file-list="false" :on-success="(res, file) => { return handleInterfaceSuccess1(res, file, 'receiveprize_bg_img')}" :before-upload="beforeAvatarUpload">
                                        <img :src="formInline.receiveprize_bg_img?formInline.receiveprize_bg_img:require('../../assets/images/interface_harvest.png')" style="width:100px;height:150px;display:block;">
                                        <i v-if="formInline.receiveprize_bg_img" class="removeImg el-icon-circle-close-outline" @click="handleRemove('receiveprize_bg_img')"></i>
                                    </el-upload>
                                    <p class="interface_update_p" style="margin-left:133px">建议尺寸375px*667px，大小500kb以内，格式为jpg,png</p>
                                </el-form-item>
                                <el-form-item label="立即领取" class="cover_img" style="border:none;text-align:left;margin-bottom:0">
                                    <el-upload class="avatar-uploader" name="file_upload" :action="uploadURL" :show-file-list="false" :on-success="(res, file) => { return handleInterfaceSuccess1(res, file, 'receiveprize_btn_img')}" :before-upload="beforeAvatarUpload">
                                        <img :src="formInline.receiveprize_btn_img?formInline.receiveprize_btn_img:require('../../assets/images/getprize_btn_img.png')" style="width:99px;height:28px;display:block;">
                                        <i v-if="formInline.receiveprize_btn_img" class="removeImg el-icon-circle-close-outline" @click="handleRemove('receiveprize_btn_img')"></i>
                                    </el-upload>
                                    <p class="interface_update_p" style="margin-left:130px">建议尺寸160px*32px，大小500kb以内，格式为jpg,png</p>
                                </el-form-item>
                            </el-form>
                        </div>
                        <div v-if="interfaceId === 4" class="interface_form">
                            <el-form :inline="false" class="acivity-prize-form" label-width="72px">
                                <el-form-item label="助力页面" class="cover_img" style="border:none;text-align:left;margin-bottom:0">
                                    <el-upload class="avatar-uploader" name="file_upload" :action="uploadURL" :show-file-list="false" :on-success="(res, file) => { return handleInterfaceSuccess1(res, file, 'assistance_img')}" :before-upload="beforeAvatarUpload">
                                        <img :src="formInline.assistance_img?formInline.assistance_img:require('../../assets/images/assistance_img.png')" style="width:160px;height:177px;display:block;">
                                        <i v-if="formInline.assistance_img" class="removeImg el-icon-circle-close-outline" @click="handleRemove('assistance_img')"></i>
                                    </el-upload>
                                    <p class="interface_update_p" style="margin-left:190px">建议尺寸270px*300px，大小500kb以内，格式为jpg,png</p>
                                </el-form-item>
                                <el-form-item label="给他助力" class="cover_img" style="border:none;text-align:left;margin-bottom:0">
                                    <el-upload class="avatar-uploader" name="file_upload" :action="uploadURL" :show-file-list="false" :on-success="(res, file) => { return handleInterfaceSuccess1(res, file, 'assistance_btn_img')}" :before-upload="beforeAvatarUpload">
                                        <img :src="formInline.assistance_btn_img?formInline.assistance_btn_img:require('../../assets/images/assistance_btn_img.png')" style="width:99px;height:28px;display:block;">
                                        <i v-if="formInline.assistance_btn_img" class="removeImg el-icon-circle-close-outline" @click="handleRemove('assistance_btn_img')"></i>
                                    </el-upload>
                                    <p class="interface_update_p" style="margin-left:130px">建议尺寸160px*32px，大小500kb以内，格式为jpg,png</p>
                                </el-form-item>
                            </el-form>
                        </div>
                        <div v-if="interfaceId === 5" class="interface_form">
                            <el-form :inline="false" class="acivity-prize-form" label-width="85px" label-position="left">
                                <el-form-item label="关注页面" class="cover_img" style="border:none;text-align:left;margin-bottom:0">
                                    <el-upload class="avatar-uploader" name="file_upload" :action="uploadURL" :show-file-list="false" :on-success="(res, file) => { return handleInterfaceSuccess1(res, file, 'qrcode_bg_img')}" :before-upload="beforeAvatarUpload">
                                        <img :src="formInline.qrcode_bg_img?formInline.qrcode_bg_img:require('../../assets/images/interface_er.png')" style="width:100px;height:150px;display:block;">
                                        <i v-if="formInline.qrcode_bg_img" class="removeImg el-icon-circle-close-outline" @click="handleRemove('qrcode_bg_img')"></i>
                                    </el-upload>
                                    <p class="interface_update_p" style="margin-left:134px">建议尺寸375px*667px，大小500kb以内，格式为jpg,png</p>
                                </el-form-item>
                                <el-form-item label="二维码图片" class="cover_img" style="border:none;text-align:left;margin-bottom:0">
                                    <el-upload class="avatar-uploader" name="file_upload" :action="uploadURL" :show-file-list="false" :on-success="(res, file) => { return handleInterfaceSuccess1(res, file, 'qrcode_img')}" :before-upload="beforeAvatarUpload">
                                        <img v-if="formInline.qrcode_img" :src="formInline.qrcode_img" style="width:110px;height:110px;display:block;">
                                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                        <i v-if="formInline.qrcode_img" class="removeImg el-icon-circle-close-outline" @click="handleRemove('qrcode_img')"></i>
                                    </el-upload>
                                    <p class="interface_update_p" :style="{marginLeft:(formInline.qrcode_img?'138px':'110px')}">建议尺寸150px*150px，大小500kb以内，格式为jpg,png</p>
                                </el-form-item>
                            </el-form>
                        </div>
                        <div v-if="interfaceId === 6" class="interface_form">
                            <el-form :inline="false" class="acivity-prize-form" label-width="80px" label-position="left">
                                <el-form-item label="预热页面" class="cover_img" style="border:none;text-align:left;margin-bottom:0">
                                    <el-radio-group v-model="formInline.is_show_preintro">
                                        <el-radio :label="0">不显示</el-radio>
                                        <el-radio :label="1">显示</el-radio>
                                    </el-radio-group>
                                    <p class="wechat_share" v-if="formInline.is_show_preintro === 1" style="margin-top: 5px;">
                                        提前
                                        <el-input-number v-model="formInline.preintro_days" controls-position="right" :min="1" style="width:88px;margin-bottom: 5px;"></el-input-number>
                                        天显示
                                    </p>
                                </el-form-item>
                                <el-form-item label="预热图" class="cover_img" style="border:none;text-align:left;margin-bottom:0">
                                    <el-upload class="avatar-uploader" name="file_upload" :action="uploadURL" :show-file-list="false" :on-success="(res, file) => { return handleInterfaceSuccess1(res, file, 'preheat_bg_img')}" :before-upload="beforeAvatarUpload">
                                        <img :src="formInline.preheat_bg_img?formInline.preheat_bg_img:require('../../assets/images/preheat_bg_img.png')" style="width:100px;height:150px;display:block;">
                                        <i v-if="formInline.preheat_bg_img" class="removeImg el-icon-circle-close-outline" @click="handleRemove('preheat_bg_img')"></i>
                                    </el-upload>
                                    <p class="interface_update_p" style="margin-left:129px">建议尺寸365px*667px，大小500kb以内，格式为jpg,png</p>
                                </el-form-item>
                                <el-form-item label="预告按钮" class="cover_img" style="border:none;text-align:left;margin-bottom:0">
                                    <el-upload class="avatar-uploader" name="file_upload" :action="uploadURL" :show-file-list="false" :on-success="(res, file) => { return handleInterfaceSuccess1(res, file, 'preheat_btn_img')}" :before-upload="beforeAvatarUpload">
                                        <img :src="formInline.preheat_btn_img?formInline.preheat_btn_img:require('../../assets/images/preheat_btn_img.png')" style="width:160px;height:24px;display:block;">
                                        <i v-if="formInline.preheat_btn_img" class="removeImg el-icon-circle-close-outline" @click="handleRemove('preheat_btn_img')"></i>
                                    </el-upload>
                                    <p class="interface_update_p" style="margin-left:190px">建议尺寸260px*40px，大小500kb以内，格式为jpg,png</p>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                    <div style="width:190px;margin: 0 0 20px 40%;" class="interface_btn">
                        <el-button class="dialog-confirm-btn" style="margin-left: 10px" type="primary" @click="addActivitys()">保存</el-button>
                        <el-button class="dialog-cancel-btn" @click="curId = 3">上一步</el-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { API_HOST } from '@/api/local'
import { regionDataPlus, CodeToText } from 'element-china-area-data'
import { getWechatPublicListForNode, getCustomerSourceListForWepage, getActivitysDetail, editActivitys } from '@/api/activity.js'
export default {
  name: 'add-activitys',
  data() {
    return {
      addressShow: false, // 收货地址界面配置
      basicData: false,
      basicSenior: false,
      activitySenior: false,
      prizeArea: false,
      timeSlot: false,
      options: regionDataPlus,
      selectedOptions: [],
      curId: 0,
      interfaceId: 0,
      dateoutbound: [],
      sources: [],
      activetyOptions: [{
        value: 1,
        label: '二维码布奖活动'
      },
        //{
        //    value: 2,
        //    label: '微信活动'
        //}
      ],
      level: ['一等奖', '二等奖', '三等奖', '四等奖', '五等奖', '六等奖'],
      date: [],
      formInline: {
        template_id: this.$route.query.template_id,
        date: [],
        activity_type: '',
        name: '',
        start_time: '',
        end_time: '',
        outbound_begin_time: '',
        outbound_end_time: '',
        source_content: '',
        province: '',
        city: '',
        district: '',
        goods: '',
        goods_status: 0,
        draw_num: 1,
        everyday_draw_num: 1,
        winning_prize_num: 1,
        assistance_prize_num: 1,
        share_prize_num: 1,
        is_question: 0,
        set_up: 1,
        receive_way: 1,
        lottery_num: 1,
        source_id: '',
        wechat_share: 1,
        public_id: '',
        // cover_img: '',
        // background_img: '',
        share_img: '',
        share_title: '',
        share_description: '',
        assistance_status: 2,
        everyactivity_assistance_prize_num: 1,
        everyday_assistance_prize_num: 1,
        assistance_prize_status: 0,
        everyday_assistance_num: 1,
        everyday_assistance_one_num: 1,
        // 预计人数
        active_number: '',
        assistance_active_number: '',
        // active_img: '',
        template: '',
        draw_type: 1,
        description: '',
        show_num: 0,
        strategystate: 2,
        strategyareastate: 2,
        strategytimestate: 2,
        strategy: [],
        strategyarea: [],
        strategytime: [],
        assistance_prize: [],
        prize: [{
          prize_level: 1,
          prize_type: 1,
          prize_name: '',
          prize_number: '',
          prize_num: 1,
          prize_num_show: '',
          prize_max_money: '',
          prize_min_money: ''
        }],
        background_img: '',
        cover_img: '',
        active_img: '',
        active_btn_img: '',
        prizeshow_img: '',
        intro_img: '',
        getprize_img: '',
        getprize_btn_img: '',
        noprize_img: '',
        assistance_share_btn_img: '',
        receiveprize_bg_img: '',
        receiveprize_btn_img: '',
        assistance_img: '',
        assistance_btn_img: '',
        qrcode_img: '',
        qrcode_bg_img: '',
        preheat_bg_img: '',
        preheat_btn_img: '',
        is_show_preintro: 0,
        preintro_days: ''
      },
      publicOptions: [],
      num8: 1,
      tableData: [{
        index: '1'
      }],
      prizeOptions: [{
        value: 1,
        label: '实物'
      },
        {
          value: 2,
          label: '红包'
        }
      ],
      cycleOptions: [{
        value: 1,
        text: 'day',
        label: '每天'
      },
        {
          value: 2,
          text: 'activityday',
          label: '活动期间'
        }
      ],
      cycleTimeOptions: [{
        value: 1,
        text: 'day',
        label: '每天'
      },
        {
          value: 2,
          text: 'custom',
          label: '指定日期'
        }
      ],
      prizeLevelOptions: [{
        value: 1,
        label: '一等奖'
      },
        {
          value: 2,
          label: '二等奖'
        }
      ],
      rules: {
        name: [
          { required: true, message: '请输入活动名称', trigger: 'blur' }
        ],
        date: [
          { required: true, message: '请选择活动时间', trigger: 'blur' }
        ],
        description: [
          { required: true, message: '请输入活动说明', trigger: 'blur' }
        ],
        source_content: [
          { required: true, message: '请输入来源说明', trigger: 'blur' }
        ],
        source_id: [
          { required: true, message: '请选择客户来源', trigger: 'blur' }
        ],
        public_id: [
          { required: true, message: '请选择公众号', trigger: 'blur' }
        ]
        // cover_img: [
        //   { required: true, message: '请输上传活动封面图', trigger: 'blur' }
        // ]
      },
      everydayNumMax: 1,
      lotteryNumMax: 1,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 86400000
        }
      },
      pickerAppointedOptions: {
        disabledDate: (time) => {
          let _this = this
          let start = new Date(Date.parse(_this.formInline.start_time.replace(/-/g, '/')))
          let end = new Date(Date.parse(_this.formInline.end_time.replace(/-/g, '/')))
          return !((time.getTime() >= start) && (time.getTime() <= end))
        }
      },
      lotteryPeriod: [{
        value: 'day',
        label: '每天'
      }]
    }
  },
  methods: {
    // 判断时候有实物奖品
    addressShowFun() {
      this.curId = 4
      let show = false
      for (let item of this.formInline.prize) {
        if (item.prize_type === 1) {
          show = true
          this.addressShow = true
          return
        }
      }
      for (let item1 of this.formInline.assistance_prize) {
        if (item1.prize_type === 1) {
          show = true
          this.addressShow = true
          return
        }
      }
      this.addressShow = show
    },
    // 禁止好友助力时关闭为好友助力
    assistanceStatusChange() {
      if (this.formInline.assistance_status === 2) {
        this.formInline.assistance_prize_status = 0
      }
    },
    // 禁止微信分享时关闭好友助力
    wechatShareChange() {
      if (this.formInline.wechat_share === 0) {
        this.formInline.assistance_status = 2
        this.formInline.assistance_prize_status = 0
      }
    },
    handleChange0(value) {
      this.formInline.province = value[0]
      this.formInline.city = value[1]
      this.formInline.district = value[2]
    },
    // 删除策略
    deleteStrategyRow(item) {
      let index = this.formInline.strategy.indexOf(item)
      this.formInline.strategy.splice(index, 1)
    },
    deleteStrategyRow4(item) {
      let index = this.formInline.strategyarea.indexOf(item)
      this.formInline.strategyarea.splice(index, 1)
    },
    deleteStrategyRow5(item) {
      let index = this.formInline.strategytime.indexOf(item)
      this.formInline.strategytime.splice(index, 1)
    },
    deleteRow(index, rows) {
      if (this.formInline.prize.length <= 1) {
        _g.toastMsg('error', '至少要有一个奖项')
        return
      }
      rows.splice(index, 1)
    },
    deleteAssistanceRow(index, rows) {
      if (this.formInline.assistance_status === 1) {
        if (this.formInline.assistance_prize.length <= 1) {
          _g.toastMsg('error', '至少要有一个奖项')
          return
        }
      }
      rows.splice(index, 1)
    },
    addActivitys() {
      for (var i = 0; i < this.formInline.prize.length; i++) {
        this.formInline.prize[i].prize_level = i + 1
      }
      if (this.formInline.assistance_prize) {
        for (var j = 0; j < this.formInline.assistance_prize.length; j++) {
          this.formInline.assistance_prize[j].prize_level = j + 1
        }
      }
      if (this.formInline.strategyarea.length > 0) {
        for (var h = 0; h < this.formInline.strategyarea.length; h++) {
          this.formInline.strategyarea[h].province = this.formInline.strategyarea[h].region[0]
          this.formInline.strategyarea[h].city = this.formInline.strategyarea[h].region[1]
          this.formInline.strategyarea[h].district = this.formInline.strategyarea[h].region[2]
        }
      }
      if (this.formInline.strategytime.length > 0) {
        for (var q = 0; q < this.formInline.strategytime.length; q++) {
          this.formInline.strategytime[q].begin_time = this.formInline.strategytime[q].time[0] ? this.formInline.strategytime[q].time[0] : ''
          this.formInline.strategytime[q].end_time = this.formInline.strategytime[q].time[1] ? this.formInline.strategytime[q].time[1] : ''
          this.formInline.strategytime[q].begin_date = this.formInline.strategytime[q].date[0] ? this.formInline.strategytime[q].date[0] : ''
          this.formInline.strategytime[q].end_date = this.formInline.strategytime[q].date[1] ? this.formInline.strategytime[q].date[1] : ''
        }
      }
      this.activityId = this.$route.query.id
      editActivitys(this.activityId, this.formInline).then(res => {
        if (res.data.code === 0) {
          _g.toastMsg('success', res.data.error)
          router.push('/home/activity')
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    dateChange(value) {
      if (value) {
        this.formInline.start_time = value[0]
        this.formInline.end_time = value[1]
      } else {
        this.formInline.start_time = ''
        this.formInline.end_time = ''
      }
    },
    // 添加奖项
    addPrizeAction() {
      if (this.formInline.prize.length >= 6) {
        _g.toastMsg('error', '最多添加六个奖项')
        return
      }
      this.formInline.prize.push({
        level: '',
        prize_level: '',
        prize_type: 1,
        prize_name: '',
        prize_number: '',
        prize_num: 1,
        prize_num_show: '',
        prize_min_money: '',
        prize_max_money: ''
      })
    },
    addAssistancePrizeAction() {
      if (this.formInline.assistance_prize.length >= 6) {
        _g.toastMsg('error', '最多添加六个奖项')
        return
      }
      this.formInline.assistance_prize.push({
        level: '',
        prize_level: '',
        prize_type: 1,
        prize_name: '',
        prize_number: '',
        prize_num: 1,
        prize_num_show: '',
        prize_min_money: '',
        prize_max_money: ''
      })
    },
    // 添加中奖次数
    addNumberAwards() {
      for (var i = 0; i < this.formInline.prize.length; i++) {
        if (this.formInline.prize[i].prize_name !== '' && this.formInline.prize[i].prize_type === 1) {
          this.formInline.strategy.push({
            prize_level: 1,
            specified_times: 1,
            cycle_type: ''
          })
          return
        } else if (this.formInline.prize[i].prize_min_money !== '' && this.formInline.prize[i].prize_type === 2) {
          this.formInline.strategy.push({
            prize_level: 1,
            specified_times: 1,
            cycle_type: ''
          })
          return
        } else {
          if (this.formInline.prize.length === 1) {
            _g.toastMsg('error', '请填全奖项')
            return
          }
        }
      }
    },
    // 添加中奖区域
    addPrizeArea() {
      for (var i = 0; i < this.formInline.prize.length; i++) {
        if (this.formInline.prize[i].prize_name !== '' && this.formInline.prize[i].prize_type === 1) {
          this.formInline.strategyarea.push({
            prize_level: 1,
            number: 1,
            region: [],
            province: '',
            city: '',
            district: ''
          })
          return
        } else if (this.formInline.prize[i].prize_min_money !== '' && this.formInline.prize[i].prize_type === 2) {
          this.formInline.strategyarea.push({
            prize_level: 1,
            number: 1,
            region: [],
            province: '',
            city: '',
            district: ''
          })
          return
        } else {
          if (this.formInline.prize.length === 1) {
            _g.toastMsg('error', '请填全奖项')
            return
          }
        }
      }
    },
    // 添加时间段布奖
    addtimeSlotArea() {
      for (var i = 0; i < this.formInline.prize.length; i++) {
        if (this.formInline.prize[i].prize_name !== '' && this.formInline.prize[i].prize_type === 1) {
          this.formInline.strategytime.push({
            prize_level: 1,
            cycle_type: 'day',
            date: [],
            time: ['', ''],
            begin_date: '',
            end_date: '',
            begin_time: '',
            end_time: '',
            number: ''
          })
          return
        } else if (this.formInline.prize[i].prize_min_money !== '' && this.formInline.prize[i].prize_type === 2) {
          this.formInline.strategytime.push({
            prize_level: 1,
            cycle_type: 'day',
            date: [],
            time: ['', ''],
            begin_date: '',
            end_date: '',
            begin_time: '',
            end_time: '',
            number: ''
          })
          return
        } else {
          if (this.formInline.prize.length === 1) {
            _g.toastMsg('error', '请填全奖项')
            return
          }
        }
      }
    },
    // 会员权益图标
    handleAvatarSuccess(res, file) {
      _g.toastMsg('success', '上传成功')
      this.formInline.share_img = res.data.path
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 1
      if (!isJPG && !isPNG) {
        _g.toastMsg('error', '上传头像图片只能是 JPG/PNG 格式!')
      }
      if (!isLt2M) {
        _g.toastMsg('error', '上传活动图片大小不能超过 1MB!')
      }
      const check = (isJPG && isLt2M) || (isPNG && isLt2M)
      if (check) {
        _g.toastMsg('success', '正在上传')
      }
      return check
    },
    // 奖品 图片上传
    handlePrizeSuccess(res, file, index) {
      if (res.code != 0) {
        _g.toastMsg('error', res.error)
      }
      _g.toastMsg('success', '上传成功')
      this.formInline.prize[index].prize_img = res.data.path
    },
    handleAssistancePrizeSuccess(res, file, index) {
      if (res.code != 0) {
        _g.toastMsg('error', res.error)
      }
      _g.toastMsg('success', '上传成功')
      this.formInline.assistance_prize[index].prize_img = res.data.path
    },
    handlePrizeRemove(name, index) {
      if (name === 'prize') {
        this.formInline.prize[index].prize_img = ''
      } else if (name === 'assistance_prize') {
        this.formInline.assistance_prize[index].prize_img = ''
      }
      event.stopPropagation()
    },
    handleRemove(index) {
      if (index === 'background_img') {
        this.formInline.background_img = ''
      } else if (index === 'cover_img') {
        this.formInline.cover_img = ''
      } else if (index === 'active_img') {
        this.formInline.active_img = ''
      } else if (index === 'active_btn_img') {
        this.formInline.active_btn_img = ''
      } else if (index === 'prizeshow_img') {
        this.formInline.prizeshow_img = ''
      } else if (index === 'intro_img') {
        this.formInline.intro_img = ''
      } else if (index === 'getprize_btn_img') {
        this.formInline.getprize_btn_img = ''
      } else if (index === 'getprize_img') {
        this.formInline.getprize_img = ''
      } else if (index === 'noprize_img') {
        this.formInline.noprize_img = ''
      } else if (index === 'assistance_share_btn_img') {
        this.formInline.assistance_share_btn_img = ''
      } else if (index === 'receiveprize_bg_img') {
        this.formInline.receiveprize_bg_img = ''
      } else if (index === 'receiveprize_btn_img') {
        this.formInline.receiveprize_btn_img = ''
      } else if (index === 'assistance_btn_img') {
        this.formInline.assistance_btn_img = ''
      } else if (index === 'assistance_img') {
        this.formInline.assistance_img = ''
      } else if (index === 'qrcode_img') {
        this.formInline.qrcode_img = ''
      } else if (index === 'qrcode_bg_img') {
        this.formInline.qrcode_bg_img = ''
      } else if (index === 'preheat_btn_img') {
        this.formInline.preheat_btn_img = ''
      } else if (index === 'preheat_bg_img') {
        this.formInline.preheat_bg_img = ''
      }
      event.stopPropagation()
    },
    // 界面图片上传
    handleInterfaceSuccess(res, file, index) {
      if (res.code != 0) {
        _g.toastMsg('error', res.error)
      }
      if (index === 'background_img') {
        this.formInline.background_img = res.data.path
      } else if (index === 'cover_img') {
        this.formInline.cover_img = res.data.path
      } else if (index === 'active_img') {
        this.formInline.active_img = res.data.path
      } else if (index === 'active_btn_img') {
        this.formInline.active_btn_img = res.data.path
      } else if (index === 'prizeshow_img') {
        this.formInline.prizeshow_img = res.data.path
      } else if (index === 'intro_img') {
        this.formInline.intro_img = res.data.path
      } else if (index === 'getprize_btn_img') {
        this.formInline.getprize_btn_img = res.data.path
      } else if (index === 'getprize_img') {
        this.formInline.getprize_img = res.data.path
      }
      _g.toastMsg('success', '上传成功')
    },
    handleInterfaceSuccess1(res, file, index) {
      if (res.code != 0) {
        _g.toastMsg('error', res.error)
      }
      if (index === 'noprize_img') {
        this.formInline.noprize_img = res.data.path
      } else if (index === 'assistance_share_btn_img') {
        this.formInline.assistance_share_btn_img = res.data.path
      } else if (index === 'receiveprize_bg_img') {
        this.formInline.receiveprize_bg_img = res.data.path
      } else if (index === 'receiveprize_btn_img') {
        this.formInline.receiveprize_btn_img = res.data.path
      } else if (index === 'assistance_btn_img') {
        this.formInline.assistance_btn_img = res.data.path
      } else if (index === 'assistance_img') {
        this.formInline.assistance_img = res.data.path
      } else if (index === 'qrcode_img') {
        this.formInline.qrcode_img = res.data.path
      } else if (index === 'qrcode_bg_img') {
        this.formInline.qrcode_bg_img = res.data.path
      } else if (index === 'preheat_btn_img') {
        this.formInline.preheat_btn_img = res.data.path
      } else if (index === 'preheat_bg_img') {
        this.formInline.preheat_bg_img = res.data.path
      }
      _g.toastMsg('success', '上传成功')
    },
    getPublicList() {
      getWechatPublicListForNode().then((res) => {
        for (let item of res.data.data.list) {
          this.publicOptions.push({
            label: item.nick_name,
            value: item.id
          })
        }
      })
    },
    // 获取客户来源
    getSourceList() {
      getCustomerSourceListForWepage(1).then((res) => {
        if (res.data.code === 0) {
          this.sources = res.data.data.list
        }
        this.getData()
      })
    },
    getData() {
      this.activityId = this.$route.query.id
      getActivitysDetail(this.activityId).then(res => {
        // this.formInline.prize = []
        // this.formInline.assistance_prize = []
        // this.formInline.strategyarea = []
        // this.formInline.strategytime = []
        for (let item of res.data.data.strategyarea) {
          item.region = [item.province ? item.province : '', item.city ? item.city : '', item.district ? item.district : '']
        }
        for (let item of res.data.data.strategytime) {
          item.time = [item.begin_time, item.end_time]
          item.date = [item.begin_date ? item.begin_date : '', item.end_date ? item.end_date : '']
        }
        this.formInline = JSON.parse(JSON.stringify(res.data.data))
        this.date = [this.formInline.start_time, this.formInline.end_time]
        // 判断客户来源是否删除
        let sourceShow = false
        for (let item of this.sources) {
          if (this.formInline.source_id === item.id) {
            sourceShow = true
          }
        }
        if (!sourceShow) {
          this.formInline.source_id = ''
        }
        // this.dateoutbound = [this.formInline.outbound_begin_time, this.formInline.outbound_end_time]
      })
    },
    interfaceFun(id) {
      // 显示界面的滚动条滚动的顶部
      document.getElementById('interfaceImg').scrollTop = 0
      this.interfaceId = id
    }
  },
  components: {},
  computed: {
    uploadURL() {
      return API_HOST + 'admin/Upload/upload'
    }
  },
  created() {
    this.getPublicList()
    this.getSourceList()
  }
}

</script>
<style scoped>
.create-acivity {
    display: flex;
    justify-content: flex-start;
    flex-direction: row;
    width: calc(100% - 40px);
    background: #fff;
    margin: 20px auto 0;
    overflow-x: hidden;
}

.wechat_share {
    margin: 0;
    line-height: 20px;
}

.new_name {
    width: 100%;
    border-bottom: 1px dotted #D1D1D1;
    line-height: 30px;
    margin-bottom: 10px;
    cursor: pointer;
    text-align: left;
}

.cover_img {
    border: 1px solid #d4d4d4;
    padding: 10px;
    border-radius: 5px;

}

.avatar-uploader {
    margin: 8px 0 0 8px;
}

.avatar-uploader-icon {
    font-size: 22px;
    color: #8c939d;
    width: 80px;
    height: 80px;
    line-height: 80px;
    text-align: center;
}

.avatar {
    width: 40px;
    height: 40px;
    display: block;
    margin-left: 20px;
}

.acivity-right {
    margin: 0 auto;
    width: 100%;
    /*height: 800px;*/
    align-items: center;
    display: block;
    justify-content: center;
    /*margin-left: -30px;*/
}

.mobile-img {
    position: absolute;
}

.scrol-image {
    /*margin-left: 130px;*/
}

.liuhai {
    position: absolute;
    top: 113px;
    z-index: 100;
}

.scrol-image,
.scrol-image .el-carousel__item {
    height: 575px;
    width: 266px;
    border-radius: 26px;
}

.el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
}

.tab-tit {
    width: 100%;
    margin: 0 auto;
    margin-bottom: 20px;
    overflow: hidden;
    border-bottom: 1px solid #E7E7E7;
}

.tab-tit .cur {
    /*background: #4486ff;*/
    color: #1980FF;
}

.tab-tit .line,
.saveData .line {
    width: 90%;
    margin: 2% auto;
    border: 0.5px dashed #d2d2d2;
}

.tab-tit a {
    cursor: pointer;
    display: block;
    float: left;
    width: 130px;
    height: 38px;
    line-height: 38px;
    font-size: 16px;
    text-align: center;
    background: #fff;
    color: #333;
    border: 1px solid #1890FF;
}

.acivity-content-form {
    width: 534px;
    text-align: left;
    margin: auto;
}

.acivity-setting-form {
    width: 534px;
    text-align: center;
    margin: auto;
}

.acivity-prize-form {
    /*text-align: center;*/
    /*margin: 0 auto;*/
    width: 100%;
}

.acivity-content-form .el-form-item__content {
    width: 300px;
}

.acivity-content-form p {
    margin: 0px;
    line-height: 20px;
    text-align: left;
    color: #999;
    font-size: 12px;
}

.prize-count {
    width: 100px;
}

.prize-count-special {
    width: 90px;
}

.prize-percent {
    width: 80px;
}

.prize-percent .el-input {
    width: 60px;
}

.prize-percent .el-input__inner {
    width: 60px;
    height: 36px;
}

.home-pic {
    width: 100%;
    height: 100%;
}

.avatar-pic {
    height: 110px;
    width: 327px;
    display: block;
}

.prize-pic {
    height: 110px;
    width: 110px;
    display: block;
}

.button-content {
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    margin-top: 20px;
}

.new-add-setting {
    width: 100%;
    height: 40px;
    line-height: 40px;
    text-align: left;
    /*margin-left: 30px;*/
    /*margin-top: 30px;*/
}

.new-add-table {
    width: 100%;
    margin-top: 10px;
}

.tags-text-item {
    width: 200px;
}

.tip-view {
    margin-left: 20px;
    margin-top: 10px;
    text-align: left;
    font-size: 14px;
    color: #666;
}

.money-span {
    display: block;
    margin-top: 5px;
    margin-left: 5px;
    margin-right: 5px;
}

@media screen and (min-width: 1600px) {
    .acivity-left {
        width: 35%;
        justify-content: flex-end;
        margin-right: 100px;
    }

    .mobile-img {
        right: -23px;
    }

    .liuhai {
        right: 60px;
    }
}

/*界面配置*/
.interface_tab {
    width: 150px;
    text-align: left;
}

.interface_tab ul {
    padding: 0;
}

.interface_tab li {
    list-style: none;
    line-height: 60px;
    cursor: pointer;
}

.interface {
    background: #E5E5E5;
    width: 365px;
    height: 610px;
    border-radius: 35px;
    overflow-x: hidden;
}

.interface_img {
    background-color: #fff;
    width: 325px;
    margin: 31px auto 32px;
    height: 547px;
    overflow-x: hidden;
    overflow-y: auto;
    position: relative;
}

.interface_con {
    background: url(../../assets/images/interface_bg.png) no-repeat;
    background-size: 100% 100%;
    min-height: 547px;
    box-sizing: border-box;
    border: 1px solid transparent;
}

.interface_hei {
    min-height: 979px;
}

.interfaceId {
    color: #1980FF;
}

.interface_form {
    min-width: 350px;
    margin-left: 40px;
}

.interface_update_p {
    margin: 0;
    line-height: 27px;
    margin-left: 167px;
    margin-top: -40px;
    font-size: 12px;
}

.removeImg {
    position: absolute;
    top: -11px;
    right: -16px;
    font-size: 19px;
    display: inline-block;
    color: #cfcaca;
}

.interface_prize_new {
    /*background: url(../../assets/images/interface_prize_bg.png);*/
    border: 1px solid #FFC100;
    border-radius: 3px;
    background-size: 100% 100%;
    width: 90%;
    margin: 0 auto;
    min-height: 100pt;
    padding-top: 10px;
    box-sizing: border-box;
    /*overflow: hidden;*/
    overflow-x: auto;
}

.interface_prize_new ul {
    width: 360px;
    margin: 0;
    padding: 0;
}

.interface_prize_new li {
    list-style: none;
    float: left;
    width: 71px;
    padding: 10px 6px 0;
    box-sizing: border-box;
}

.interface_prize_new li div {
    height: 60px;
    width: 60px;
    border-radius: 50%;
    border: 1px solid #FFF1AF;
    background: #fff;
    /*padding-top: 12px;*/
    box-sizing: border-box;
    position: relative;
}

.interface_prize_new li div img {
    max-width: 80%;
    max-height: 48px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%)
}

.interface_prize_new li p {
    color: #FFF1AF;
    margin: 10px 0 0;
    font-size: 13px;
}

.interface_rule {
    margin-bottom: 20px;
    color: #FFF1AF;
    line-height: 28px;
    height: auto;
    padding: 0 10px;
    text-align: left
}

.mask {
    background: rgba(0, 0, 0, 0.58);
    overflow: hidden !important;
    position: absolute;
    width: 100%;
    height: 547px;
    z-index: 3;
}

.close {
    position: absolute;
    top: 0;
    right: 0;
    width: 30px
}

.interface_prize {
    max-width: 100px;
    max-height: 100px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.harvest {
    color: #FD7980;
    background: #fff;
    line-height: 34px;
    width: 79%;
    margin: 0 auto;
    text-align: left;
    padding-left: 8px;
    box-sizing: border-box;
    border-radius: 3px;
}

.harvest_con {
    padding-top: 280px;
    box-sizing: border-box;
}

.interface_altar {
    position: absolute;
    left: 6px;
    top: -23px;
    height: 200px;
}

.interface_altar_open {
    position: absolute;
    left: 47px;
    top: 113px;
    height: 40px;
    width: 40px;
    z-index: 2
}

.qrcode_con {
    margin: 0;
    color: #fff;
    font-size: 12px;
    line-height: 17px;
}

.interface_btn {
    margin-top: 20px !important;
}

.tab-tit ul {
    width: 900px;
    display: block;
    margin: 0 auto;
}

.tab-tit ul li {
    list-style: none;
    float: left;
    width: 180px;
    height: 80px;
    position: relative;
    text-align: right;
    padding-top: 11px;
    box-sizing: border-box;
    cursor: pointer;
}

.tab-tit ul li img {
    width: 36px;
    margin-right: 5px;
}

.tab-tit ul li p {
    margin: 0;
    font-size: 12px;
    margin-top: 4px;
}

.tab-tit ul li span {
    position: absolute;
    display: inline-block;
    width: 145px;
    height: 1px;
    background: #C7C7C7;
    top: 30px;
    left: -4px;
}

.tab-tit ul li.cur span {
    background: #1980FF;
}

.tab-con {
    width: 90%;
    margin: 0 auto;
    overflow-x: auto;
}

</style>
